module.exports = __webpack_public_path__ + "static/media/users.ac822f9b.svg";